import { render, staticRenderFns } from "./gov_announce_story_body.vue?vue&type=template&id=026b6a5f&scoped=true&lang=pug"
import script from "./gov_announce_story_body.vue?vue&type=script&lang=js"
export * from "./gov_announce_story_body.vue?vue&type=script&lang=js"
import style0 from "./gov_announce_story_body.vue.css?vue&type=style&index=0&id=026b6a5f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026b6a5f",
  null
  
)

export default component.exports